import type { RingCellKind } from '@goodtime/shared';

/**
 * The Royal Road's sounds, by moment: aliases of the app's road audio
 * (assets/audio/road). Each is levelled to about -16 LUFS with peaks under
 * -1 dBTP; the chase tick and tock are 60 ms and a little quieter, since
 * they repeat.
 */
export const ROAD_SOUNDS = {
  /** The board sweeps over the reels, then the sting. */
  sweep: 'road:sweep_whoosh',
  runStart: 'road:run_sting',
  /** The light passing lamps, tick and tock in turn. */
  chaseTick: 'road:chase_tick',
  chaseTock: 'road:chase_tock',
  /** The light settles on a cell. */
  landed: 'road:landed',
  coins: ['road:coin_single_1', 'road:coin_single_2', 'road:coin_single_3', 'road:coin_single_4'],
  coinBurst: 'road:coin_burst',
  freeSpins: 'road:hilo_rung_up',
  bomb: 'road:bomb_pop',
  /** An acorn spent on a bomb, just after the pop. */
  acornUsed: 'road:acorn_used',
  /** The run pot is collected. */
  collected: 'road:run_fanfare',
  hiloFlip: 'road:hilo_flip',
  hiloRungUp: 'road:hilo_rung_up',
  hiloEnd: 'road:hilo_end',
  /** A landmark on the road is restored. */
  restored: 'road:restore_done',
  /** The last one: the chapter is done. */
  chapterDone: 'road:chapter_done',
} as const;

/** What a landing pays out sounds like, by the cell it landed on. `pick`
 *  (0 to 1) chooses among the single coins, so repeats vary. */
export function landingSound(kind: RingCellKind, pick = Math.random()): string {
  if (kind === 'bomb') return ROAD_SOUNDS.bomb;
  if (kind === 'free_spins') return ROAD_SOUNDS.freeSpins;
  if (kind === 'coins_small') {
    const coins = ROAD_SOUNDS.coins;
    return coins[Math.min(coins.length - 1, Math.floor(pick * coins.length))] ?? coins[0];
  }
  // Big coins, the silver pot and friends' lamps.
  return ROAD_SOUNDS.coinBurst;
}
